module.exports = __webpack_public_path__ + "static/media/seo-company400x221.5efd71b3.jpg";